import React from 'react';
import { FileText, Download, RefreshCw } from 'lucide-react';

interface DashboardHeaderProps {
  isFetching: boolean;
  onOpenExportPdfModal: () => void;
  onOpenExportCsvModal: () => void;
  onRefetch: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  isFetching,
  onOpenExportPdfModal,
  onOpenExportCsvModal,
  onRefetch,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
            Dasbor Statistik Real-Time
          </h1>
          <span className="flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
            <span>Real-Time</span>
          </span>
        </div>
        <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
          Metrik pendaftaran buku, verifikasi kode UIBN, dan aktivitas pemindaian pembaca.
        </p>
      </div>

      <div className="flex items-center gap-2.5 self-start sm:self-auto shrink-0 flex-wrap">
        <button
          type="button"
          id="btn-dashboard-export-pdf"
          onClick={onOpenExportPdfModal}
          className="px-3.5 py-1.5 bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white rounded-xl text-xs font-bold shadow-xs transition flex items-center gap-1.5 cursor-pointer"
          title="Cetak Laporan PDF Ringkasan Inventaris & Pemindaian Buku UIBN"
        >
          <FileText className="w-3.5 h-3.5" />
          <span>Laporan PDF</span>
        </button>

        <button
          type="button"
          id="btn-dashboard-export-csv"
          onClick={onOpenExportCsvModal}
          className="px-3.5 py-1.5 bg-white hover:bg-indigo-50 text-indigo-700 border border-indigo-200 hover:border-indigo-300 rounded-xl text-xs font-semibold shadow-2xs transition flex items-center gap-1.5 cursor-pointer"
          title="Ekspor Data Katalog Buku ke CSV dengan Filter Tanggal"
        >
          <Download className="w-3.5 h-3.5 text-indigo-600" />
          <span>Ekspor CSV</span>
        </button>

        <button
          type="button"
          onClick={onRefetch}
          className="px-3.5 py-1.5 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 rounded-xl text-xs font-semibold shadow-2xs transition flex items-center gap-1.5 cursor-pointer"
        >
          <RefreshCw className={`w-3.5 h-3.5 text-slate-500 ${isFetching ? 'animate-spin' : ''}`} />
          <span>Segarkan Data</span>
        </button>
      </div>
    </div>
  );
};
